var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c("h4", { staticClass: "mb-1" }, [
            _vm._v(_vm._s(_vm.$t("influencer_level.title"))),
          ]),
          _c("small", { staticClass: "text-muted d-block mb-3" }, [
            _vm._v(_vm._s(_vm.$t("influencer_level.hint"))),
          ]),
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col sm:w-5/12 w-full" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("influencer_level.name"),
                      "label-for": "name",
                    },
                  },
                  [
                    _c("b-form-input", {
                      staticClass: "required",
                      attrs: { id: "name", type: "text" },
                      model: {
                        value: _vm.model.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "name", $$v)
                        },
                        expression: "model.name",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col sm:w-3/12 w-full" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("influencer_level.rank"),
                      "label-for": "rank",
                    },
                  },
                  [
                    _c("b-form-input", {
                      staticClass: "required",
                      attrs: { id: "rank", type: "number", min: "1" },
                      model: {
                        value: _vm.model.rank,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "rank", $$v)
                        },
                        expression: "model.rank",
                      },
                    }),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.$t("influencer_level.rank_hint"))),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col sm:w-4/12 w-full" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("influencer_level.bonus"),
                      "label-for": "commission_bonus_pct",
                    },
                  },
                  [
                    _c(
                      "b-input-group",
                      { attrs: { append: "%" } },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: "commission_bonus_pct",
                            type: "number",
                            step: "0.1",
                            min: "0",
                            max: "100",
                          },
                          model: {
                            value: _vm.model.commission_bonus_pct,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "commission_bonus_pct", $$v)
                            },
                            expression: "model.commission_bonus_pct",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.$t("influencer_level.bonus_hint"))),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("h5", { staticClass: "mb-1" }, [
            _vm._v(_vm._s(_vm.$t("influencer_level.requirements"))),
          ]),
          _c("small", { staticClass: "text-muted d-block mb-2" }, [
            _vm._v(_vm._s(_vm.$t("influencer_level.requirements_hint"))),
          ]),
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col sm:w-4/12 w-full" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("influencer_level.min_followers"),
                      "label-for": "min_followers",
                    },
                  },
                  [
                    _c("b-form-input", {
                      attrs: { id: "min_followers", type: "number", min: "0" },
                      model: {
                        value: _vm.model.min_followers,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "min_followers", $$v)
                        },
                        expression: "model.min_followers",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col sm:w-4/12 w-full" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("influencer_level.min_conversions"),
                      "label-for": "min_conversions",
                    },
                  },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "min_conversions",
                        type: "number",
                        min: "0",
                      },
                      model: {
                        value: _vm.model.min_conversions,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "min_conversions", $$v)
                        },
                        expression: "model.min_conversions",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col sm:w-4/12 w-full" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("influencer_level.min_sales_amount"),
                      "label-for": "min_sales_amount",
                    },
                  },
                  [
                    _c(
                      "b-input-group",
                      { attrs: { prepend: "R$" } },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: "min_sales_amount",
                            type: "number",
                            step: "0.01",
                            min: "0",
                          },
                          model: {
                            value: _vm.model.min_sales_amount,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "min_sales_amount", $$v)
                            },
                            expression: "model.min_sales_amount",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col sm:w-4/12 w-full" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("influencer_level.badge_color"),
                      "label-for": "badge_color",
                    },
                  },
                  [
                    _c("b-form-select", {
                      attrs: { id: "badge_color", options: _vm.colorList },
                      model: {
                        value: _vm.model.badge_color,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "badge_color", $$v)
                        },
                        expression: "model.badge_color",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col sm:w-4/12 w-full" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("influencer_level.status"),
                      "label-for": "status",
                    },
                  },
                  [
                    _c("b-form-radio-group", {
                      attrs: { id: "status", options: _vm.statusList },
                      model: {
                        value: _vm.model.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "status", $$v)
                        },
                        expression: "model.status",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "b-form-group",
            {
              attrs: {
                label: _vm.$t("influencer_level.benefits"),
                "label-for": "benefits",
              },
            },
            [
              _c("b-form-textarea", {
                attrs: { id: "benefits", rows: "2" },
                model: {
                  value: _vm.model.benefits,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "benefits", $$v)
                  },
                  expression: "model.benefits",
                },
              }),
            ],
            1
          ),
          _c(
            "b-form-row",
            { staticClass: "justify-end mt-2" },
            [
              _c(
                "b-col",
                { attrs: { cols: "auto" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.createOrUpdate },
                    },
                    [_vm._v(_vm._s(_vm.$t("save")))]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "auto" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-secondary" },
                      on: { click: _vm.goBack },
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-50",
                        attrs: { icon: "CornerUpLeftIcon" },
                      }),
                      _c("span", { staticClass: "align-middle" }, [
                        _vm._v(_vm._s(_vm.$t("back"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }